module.exports = masker;